module.exports = __webpack_public_path__ + "media/images/sponsorImage-e0ee4d91a45676a4566cb7ae5acb198f.png";